import { useState } from "react";
import { View } from "../base";
import { SpanDetailTabs, TabDefinition } from "./SpanDetailTabs";
import { RawSpanDetailView, RawSpanData } from "./RawSpanDetailView";
import { SpanEventsContent } from "./SpanEventsContent";

/**
 * Tabbed fallback for span types without a specialized detail view (e.g. the
 * proxy outer "completion" span, with kind=INTERNAL and only voicerun.* /
 * completion.* attributes). Always shows Attributes; adds an Events tab when
 * the span carries OTLP events (per-attempt fallback history, custom
 * events from agents, etc.).
 */
interface GenericSpanDetailViewProps {
  rawData: RawSpanData;
  className?: string;
}

export const GenericSpanDetailView = ({ rawData, className }: GenericSpanDetailViewProps) => {
  const events = rawData.events ?? [];
  const tabs: TabDefinition[] = [
    { id: "attributes", label: "Attributes", color: "gray" },
    ...(events.length > 0 ? [{ id: "events", label: `Events (${events.length})`, color: "amber" as const }] : []),
  ];
  const [activeTab, setActiveTab] = useState(events.length > 0 ? "events" : "attributes");

  return (
    <View className={`flex flex-col overflow-hidden h-full ${className || ""}`}>
      <SpanDetailTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />
      <View className="flex-1 overflow-y-auto p-4">
        {activeTab === "attributes" && <RawSpanDetailView data={rawData} />}
        {activeTab === "events" && <SpanEventsContent events={events} />}
      </View>
    </View>
  );
};
